<template>
  <div class="shujuzhongxinSheng">
    <BaseDrawer direction="rtl" :ShowClose="true">
      <div class="wrap">
        <Title />
        <div class="box">
          <div class="jcxx">
            <Collapse
              title="基础信息"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="jcxxIsShow"
            >
              <Tag
                v-for="(item, index) in fuwuqibiaozhunjcxx"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </Collapse>
          </div>
          <div class="ztxx">
            <Collapse
              title="状态信息"
              :iconUrl="require('../../../assets/img/SSGJ/ztxxIcon.png')"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="ztxxIsShow"
            >
              <Tag
                v-for="(item, index) in fuwuqibiaozhunztxx"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </Collapse>
          </div>
          <div class="czzl">
            <Collapse
              title="操作指令"
              :iconUrl="require('../../../assets/img/SSGJ/czzlIcon.png')"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="czzlIsShow"
            >
              <TagButton
                v-for="(item, index) in fuwuqibiaozhunczzl"
                :key="index"
                @runInHole="runInHole"
                :text="item"
                :iconUrl="btnimg[index]"
              />
            </Collapse>
          </div>
          <div class="ckll">
            <Collapse
              title="查看链路"
              :iconUrl="require('../../../assets/img/SSGJ/ckll.png')"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="ckllIsShow"
            >
              <div class="ul">
                <div
                  class="li"
                  @click="LinkLiPoint(fuwuqibiaozhunckll[0], 0)"
                  :class="i == 0 ? 'ac' : ''"
                >
                  <div class="TagButton_image">
                    <img :src="ckllimg[0]" alt />
                  </div>
                  <div class="TagButton_text">{{ fuwuqibiaozhunckll[0] }}</div>
                </div>
                <div
                  class="li"
                  @click="LinkLiPoint(fuwuqibiaozhunckll[1], 1)"
                  :class="i == 1 ? 'ac' : ''"
                >
                  <div class="TagButton_image">
                    <img :src="ckllimg[1]" alt />
                  </div>
                  <div class="TagButton_text">{{ fuwuqibiaozhunckll[1] }}</div>
                </div>
                <LinkDetails
                  v-show="i == 1"
                  :title="fuwuqibiaozhunckll[1]"
                  :closeCabinetDoor="closeCabinetDoor"
                />
                <div
                  class="li"
                  @click="LinkLiPoint(fuwuqibiaozhunckll[2], 2)"
                  :class="i == 2 ? 'ac' : ''"
                >
                  <div class="TagButton_image">
                    <img :src="ckllimg[2]" alt />
                  </div>
                  <div class="TagButton_text">{{ fuwuqibiaozhunckll[2] }}</div>
                </div>
                <LinkDetails
                  v-show="i == 2"
                  :title="fuwuqibiaozhunckll[2]"
                  :List="LinkData"
                  :closeCabinetDoor="closeCabinetDoor"
                />
              </div>
            </Collapse>
          </div>
          <div class="gjxx">
            <Collapse
              title="告警信息"
              :iconUrl="require('../../../assets/img/SSGJ/gjxxIcon.png')"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="gjxxIsShow"
            >
              <Table
                :CData="fuwuqibiaozhungjxx"
                :NavData="['时间 ', '告警级别', '内容 ']"
                :NavWidth="['278px', '128px', '200px']"
              />
            </Collapse>
          </div>
          <div class="lssj">
            <Collapse
              title="历史数据"
              :iconUrl="require('../../../assets/img/SSGJ/lssjIcon.png')"
              @changeisReceiveFair="isReceiveFair"
              :isReceiveFair="lssjIsShow"
              :isywxt="true"
            >
              <Tag :name="'CPU使用情况'" :value="''" />
              <ChartLineArea
                class="charts"
                :rowData="cpusyqk"
                left="3%"
                right="5%"
                unit="GHz"
                height="350px"
                :barColor="['#73FFFF', '#73FFFF00']"
              />
              <Tag :name="'内存使用情况'" :value="''" />
              <ChartLineArea
                class="charts"
                :rowData="ncsyqk"
                left="3%"
                right="5%"
                unit="GB"
                height="350px"
                :barColor="['#94DE6B', '#94DE6B00']"
              />
              <Tag :name="'硬盘使用情况'" :value="''" />
              <ChartLineArea
                class="charts"
                :rowData="cpsyqk"
                left="3%"
                right="5%"
                unit="TB"
                height="350px"
                :barColor="['#4DA6FF', '#4DA6FF00']"
              />
            </Collapse>
          </div>
        </div>
      </div>
    </BaseDrawer>
  </div>
</template>

<script>
import Collapse from '@/components/common/communal/Collapse'
import Pagination from '@/components/common/communal/Pagination'
import Table from '@//components/common/communal/Table'
import Tag from '@/components/common/communal/Tag'
import TagButton from '@/components/common/communal/TagButton'
import BaseDrawer from '@/components/common/BaseDrawer'
import Title from '@/components/common/communal/Title'
import ChartLineArea from '@/components/charts/ChartLineArea'
import LinkDetails from '@/components/ShiShiGaoJing/common/LinkDetails'
import { mapState } from 'vuex'
import ObjectManager from '@/utils/control/ObjectManager'
import cameraList from '@/utils/configs/cameraList'
import UEapi from '@/utils/UEapi/UEapi'

export default {
  components: {
    Collapse,
    Pagination,
    Table,
    Tag,
    TagButton,
    Title,
    BaseDrawer,
    ChartLineArea,
    LinkDetails,
  },
  data() {
    return {
      fuwuqibiaozhunjcxx: [
        {
          name: '编号',
          value: 'G2 7914AC10-01',
        },
        {
          name: '所属',
          value: 'SJZX-01-JF',
        },
        {
          name: '品牌',
          value: 'IBM',
        },
        {
          name: '型号',
          value: 'G2 7914AC10',
        },
        {
          name: '类型',
          value: '存储服务器',
        },
      ],
      fuwuqibiaozhunztxx: [
        {
          name: '设备状态',
          value: '在线',
        },
        {
          name: 'CPU负载',
          value: '11%',
        },
        {
          name: 'GPU负载',
          value: '23%',
        },
        {
          name: '内存已占用空间',
          value: '20GB',
        },
        {
          name: '内存负载',
          value: '31%',
        },
      ],
      fuwuqibiaozhunczzl: ['设备正面', '设备反面'],
      fuwuqibiaozhunckll: [
        '全部显示',
        'Server-b22 F03 BANKA 02',
        'Server-b22 F03 BANKA 04',
      ],
      fuwuqibiaozhungjxx: [
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: 'CPU使用率过高',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: 'CPU使用率过高',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
      ],
      ckllimg: [
        require('../../../assets/img/SSGJ/qbxxIcon.png'),
        require('../../../assets/img/SSGJ/ckll.png'),
        require('../../../assets/img/SSGJ/ckll.png'),
      ],
      btnimg: [
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
      ],
      jcxxIsShow: true,
      ztxxIsShow: true,
      czzlIsShow: true,
      ckllIsShow: true,
      gjxxIsShow: false,
      lssjIsShow: false,
      cpusyqk: [
        {
          name: '00:00',
          value: 40,
        },
        {
          name: '04:00',
          value: 50,
        },
        {
          name: '08:00',
          value: 30,
        },
        {
          name: '12:00',
          value: 30,
        },
        {
          name: '16:00',
          value: 20,
        },
        {
          name: '20:00',
          value: 30,
        },
        {
          name: '24:00',
          value: 40,
        },
      ],
      ncsyqk: [
        {
          name: '00:00',
          value: 40,
        },
        {
          name: '04:00',
          value: 50,
        },
        {
          name: '08:00',
          value: 30,
        },
        {
          name: '12:00',
          value: 30,
        },
        {
          name: '16:00',
          value: 20,
        },
        {
          name: '20:00',
          value: 30,
        },
        {
          name: '24:00',
          value: 40,
        },
      ],
      cpsyqk: [
        {
          name: '00:00',
          value: 40,
        },
        {
          name: '04:00',
          value: 50,
        },
        {
          name: '08:00',
          value: 30,
        },
        {
          name: '12:00',
          value: 30,
        },
        {
          name: '16:00',
          value: 20,
        },
        {
          name: '20:00',
          value: 30,
        },
        {
          name: '24:00',
          value: 40,
        },
      ],
      i: -1,
      isShowlink: false,
      LinkData: [
        {
          name: 'Server-b22',
          value: 'SQL-1',
          id: 'C03-004-04_SM_服务器',
          port: 'API_C0300404_服务器_背_F02',
          btn: ['设 备', '端 口'],
        },
        {
          name: 'SQL数据库服务_port_SQL-1_D04_ODF1_port_OP-2',
          value: 'OP-2',
          id: 'Link_SM_机柜通讯线C03',
          btn: ['配 线'],
        },
        {
          name: 'Server-b23',
          id: 'C03-004-04_SM_配线架',
          value: 'OP-3',
          port: 'API_C0300404_配线架_正_A40',
          btn: ['设 备', '端 口'],
        },
        {
          name: 'D04-ODF1_port_OPB-2_F03_ODF1_port_OP-4',
          id: 'Link_SM_机柜通讯线CA', //Link_SM_机柜通讯线CF02
          value: 'OP-4',
          btn: ['配 线'],
        },
        {
          name: 'F03-ODF1',
          id: 'A01-004-04_SM_配线架',
          value: 'OP-5',
          port: 'API_A0100404_配线架_正_A40',
          btn: ['设 备', '端 口'],
        },
        {
          name: 'D04-ODF1_port_OPB-4_F03_BANKA_01_port_OP-3',
          value: 'OP-6',
          id: 'Link_SM_机柜通讯线A01',
          btn: ['配 线'],
        },
        {
          name: 'F03-ODF1',
          value: 'OP-5',
          id: 'A01-004-04_SM_服务器',
          port: 'API_A0100404_服务器_背_F02',
          btn: ['设 备', '端 口'],
        },
      ],
      closeCabinetDoor: false,
    }
  },
  methods: {
    runInHole(p) {
      this.$emit('runInHole', p)
    },
    isReceiveFair(p) {
      let head = document.querySelectorAll('.Collapse_head')
      for (let index = 0; index < head.length; index++) {
        const element = head[index]
      }
      switch (p) {
        case '基础信息':
          this.jcxxIsShow = !this.jcxxIsShow
          break
        case '状态信息':
          this.ztxxIsShow = !this.ztxxIsShow
          break
        case '操作指令':
          this.czzlIsShow = !this.czzlIsShow
          break
        case '查看链路':
          this.ckllIsShow = !this.ckllIsShow
          break
        case '告警信息':
          this.gjxxIsShow = !this.gjxxIsShow
          break
        case '历史数据':
          this.lssjIsShow = !this.lssjIsShow
          break
      }
    },
    LinkLiPoint(item, index) {
      const lines = [...ObjectManager.linkList, ...ObjectManager.linkList_2]
      this.closeCabinetDoor = this.i == index ? true : false
      if (this.i == index) {
        if (this.i == 1 || this.i == 2) {
          this.i = -1
          UEapi.Model.setModelVisibility({ ids: lines, visible: false })
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_服务器'])
          window.layerConfig.modelOnlyHighlight('C03-004-04_SM_服务器')
          UEapi.Model.playAnimation({
            id: 'F06-004-07_SM_设备机柜',
            name: '机柜_前_关',
            state: 'begin',
          })
          UEapi.Model.playAnimation({
            id: 'F06-004-07_SM_设备机柜',
            name: '机柜_后_关',
            state: 'begin',
          })

          UEapi.Model.playAnimation({
            id: 'A01-004-04_SM_机柜组',
            name: '机柜_前_关',
            state: 'begin',
          })
          UEapi.Model.playAnimation({
            id: 'A01-004-04_SM_机柜组',
            name: '机柜_后_关',
            state: 'begin',
          })

          return
        }
        this.i = -1
      } else {
        this.i = index
      }
      switch (item) {
        case '全部显示':
          this.isShowlink = true
          UEapi.Model.setModelVisibility({ ids: lines, visible: true })
          UEapi.Camera.setCamera(cameraList['整条链路视角'])
          break
        case '全部隐藏':
          this.isShowlink = false
          UEapi.Model.setModelVisibility({ ids: lines, visible: false })
          UEapi.Camera.setCamera(cameraList['C03-004-04_SM_服务器'])
          break
        case 'Server-b22 F03 BANKA 02':
          UEapi.Model.setModelVisibility({
            ids: ObjectManager.linkList_2,
            visible: false,
          })
          UEapi.Model.setModelVisibility({
            ids: ObjectManager.linkList,
            visible: true,
          })

          UEapi.Camera.setCamera(cameraList['整条链路视角'])
          break
        case 'Server-b22 F03 BANKA 04':
          UEapi.Model.setModelVisibility({
            ids: ObjectManager.linkList,
            visible: false,
          })
          UEapi.Model.setModelVisibility({
            ids: ObjectManager.linkList_2,
            visible: true,
          })
          UEapi.Camera.setCamera(cameraList['链路二'])
          break
      }
    },
  },
  computed: {
    ...mapState(['functionStatus', 'objectInfo']),
  },
  mounted() {
    this.fuwuqibiaozhunjcxx[0].value = this.objectInfo.name
  },
  watch: {
    objectInfo: {
      handler(val) {
        this.fuwuqibiaozhunjcxx[0].value = val.name
      },
      deep: true,
    },
    isShowlink: {
      handler(val) {
        this.fuwuqibiaozhunckll[0] = val ? '全部隐藏' : '全部显示'
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 680px;
  height: 1720px;
  background: url('../../../assets/img/WLTS/left.png') no-repeat;

  .box {
    width: 100%;
    height: 1650px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .czzl {
    /deep/ .Collapse {
      .Collapse_main {
        .TagButton:nth-child(1) {
          .TagButton_image {
          }
        }
      }
    }
  }
  .ztxx {
    /deep/ .Collapse {
      .Collapse_main {
        .Tag:nth-child(1) {
          .Tag_right {
            color: #00ffbf;
          }
        }
      }
    }
  }
  .ckll {
    .ul {
      .li {
        width: 100%;
        height: 50px;
        background: #189bfa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        margin-bottom: 20px;
        .TagButton_image {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;

          & > img {
            width: 100%;
            height: 100%;
          }
        }

        .TagButton_text {
          margin-left: 10px;
          font-size: 28px;
          font-family: '微软雅黑';
          color: #ffffff;
          font-weight: bold;
        }
      }
      .ac {
        width: 100%;
        height: 50px;
        background: #116caf;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        margin-bottom: 20px;
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0px;
  border-radius: 0px;
  background: rgba(17, 63, 89, 0.65);
}
::-webkit-scrollbar-thumb {
  width: 0px;
  border-radius: 0px;
  background: rgba(255, 255, 255, 0.15);
  min-height: 00px;
}
</style>